import { render, staticRenderFns } from "./GestionEntidadesView.vue?vue&type=template&id=b21f09c2&scoped=true"
import script from "./GestionEntidadesView.vue?vue&type=script&lang=js"
export * from "./GestionEntidadesView.vue?vue&type=script&lang=js"
import style0 from "./GestionEntidadesView.vue?vue&type=style&index=0&id=b21f09c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21f09c2",
  null
  
)

export default component.exports